const updateMembershipPackageDetailsToast = (state = null, action) => {
  if (action.type === "SET_UPDATE_MEMBERSHIP_PACKAGE_DETAILS_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_UPDATE_MEMBERSHIP_PACKAGE_DETAILS_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default updateMembershipPackageDetailsToast;
